import React, { FC } from 'react';

import useStyles from './styles.module';

const Background: FC = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.backgroundContainer}>
      <div className={classes.videoSection}>
        <video className={classes.video} autoPlay loop muted playsInline>
          <source src="/images/bg/backgroundVideo.mp4" type="video/mp4" />
        </video>
        <div className={classes.videoOverlay} />
      </div>
      <div className={classes.imageWrapper}>
        <img
          src="/images/bg/backgroundImage.svg"
          alt="background"
          className={classes.backgroundImage}
        />
      </div>
    </div>
  );
};

export default Background;
